import { render, staticRenderFns } from "./OneTimeCode.vue?vue&type=template&id=dea0bd48&scoped=true"
import script from "./OneTimeCode.vue?vue&type=script&lang=js"
export * from "./OneTimeCode.vue?vue&type=script&lang=js"
import style0 from "./OneTimeCode.vue?vue&type=style&index=0&id=dea0bd48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea0bd48",
  null
  
)

export default component.exports